import React from "react";
import B2BLeadsList from "@/pages/coe/B2BLeadsList";

/* Admin shell — reuses the COE pipeline list component with scope="admin".
   Path B Phase 3 (2026-02-25). The component handles the scope difference
   internally (different API endpoint + heading + per-row "assigned to" label). */
export default function AdminB2BLeads() {
    return <B2BLeadsList scope="admin" />;
}
